// import StoreSpecials from '@common/components/StoreSpecials';
import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import ProductBundle from '@common/components/ProductBundle';
import ProductDetailsWrapper from '@common/containers/Wrapper/ProductDetailPage';
// import { ReactComponent as NextArrow } from '@common/icons/NextArrow.svg';
import { RootState } from '@common/store';
import {
  addBundleProductToCartSuccess,
  addProductToCart,
  CartSliceType,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { CategoriesSliceType, fetchCategoriesRequest } from '@common/store/categories/slice';
import { FeaturesSliceType } from '@common/store/features/slice';
import {
  fetchProductBundleRequest,
  fetchProductDetailsRequest,
  fetchProductReviewsRequest,
  ProductDetailsSliceType,
} from '@common/store/productDetails/slice';
import { ProductsSliceType } from '@common/store/products/slice';
import { fetchProductsRequest } from '@common/store/products/slice';
import { RecentlyViewedSliceType } from '@common/store/recentlyViewed/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
// import { PRODUCTS_KEY } from '@common/utils/constants';
import { getBuyerJWTToken } from '@common/utils/token';
import Event from '@components/Event';
import PageLayout from '@components/PageLayout';
import Product from '@components/Product';
import Rating from '@components/Rating';
import RecentlyViewed from '@components/RecentlyViewed';
import Share from '@components/Share';
import Toasts from '@components/Toasts';
import Down from '@images/Down.svg';
// import Toasts from '@components/Toasts';
import BreadcrumbRightArrow from '@images/RightArrow.svg';
import Editor from '@lib/Editor';
import Link from '@lib/Link';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

interface MatchParams {
  productId: string;
  productSlug: string;
}
interface ProductDetailState {
  description: boolean;
  review: boolean;
}
interface ProductDetailProps extends RouteComponentProps<MatchParams> {
  cart: CartSliceType;
  toasts: ToastWithKeyType[];
  removeToast: typeof removeToast;
  productDetails: ProductDetailsSliceType;
  products: Record<string, ProductsSliceType>;
  recentlyViewed: RecentlyViewedSliceType;
  addToast: typeof addToast;
  addProductToCart: typeof addProductToCart;
  categories: CategoriesSliceType;
  fetchCategoriesRequest: typeof fetchCategoriesRequest;
  subtractProductFromCart: typeof subtractProductFromCart;
  fetchProductsRequest: typeof fetchProductsRequest;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  storeInfo: StoreInfoSliceType;
  features: FeaturesSliceType;
  addBundleProductToCartSuccess: typeof addBundleProductToCartSuccess;
  fetchProductBundleRequest: typeof fetchProductBundleRequest;
}

class ProductDetails extends React.Component<ProductDetailProps, ProductDetailState> {
  constructor(props) {
    super(props);

    this.state = {
      description: false,
      review: false,
    };
  }

  setDescription() {
    this.setState({
      description: !this.state.description,
    });
  }

  setReview() {
    this.setState({
      review: !this.state.review,
    });
  }

  render() {
    const { productDetails, addToast, addProductToCart, cart, features, addBundleProductToCartSuccess } = this.props;

    const product = productDetails.productDetails;
    const cartProductQuantity = cart.quantityByProductId[product?.id] || 0;
    // const featuredProductsExist = this.props.products[PRODUCTS_KEY.FEATURED]?.list?.results?.length;
    // const features = this.props?.features?.features || {};
    const hideReviewsSection = !features.features?.buyerLogin && productDetails.reviews?.length === 0;
    return (
      <PageLayout hideToast>
        <ProductDetailsWrapper
          RecentlyViewed={RecentlyViewed}
          fetchCategoryReq={true}
          props={this.props}
          recentlyViewedClassnames={['container md:mx-auto px-0 mb-42', '', '']}
          showToast={false}
        >
          {!product?.isEvent ? (
            <ProductAddToCartHOC
              variantSetToMinQuantity={true}
              disableSuccessToasts={() => false}
              product={product}
              render={(hocArgs) => {
                const { finalProduct } = hocArgs;
                return (
                  <>
                    <div className="w-full shadow-breadCrumb">
                      <div
                        className="container md:mx-auto flex items-center text-black py-10 md:py-18 md:pl-62"
                        font-customisation="para-text"
                      >
                        <div className="add-ellipsis text-12 md:text-16 font-normal">
                          <Link to="/" className="mr-14 cursor-pointer text-theme" color-customisation="page-body-text">
                            Home
                          </Link>
                          <img
                            src={BreadcrumbRightArrow}
                            className="h-10 md:h-12 mr-14 -mt-2 inline-block"
                            alt="arrow"
                          />
                          <span className="font-bold" color-customisation="page-body-text">
                            {product?.title ?? ''}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={classnames('container md:mx-auto md:px-0 flex text-black md:pl-42', {
                        'h-10 md:h-42': !this.props.toasts?.length,
                        'my-10 md:my-24': this.props.toasts?.length,
                      })}
                    >
                      <Toasts toasts={this.props.toasts} addToast={addToast} removeToast={removeToast} />
                    </div>
                    <div className="container border-b border-lightGray border-opacity-15 md:border-0 relative md:px-42 md:mx-auto flex flex-wrap md:flex-no-wrap mb-5">
                      {productDetails.isFetched ? (
                        <Product
                          subtractProductFromCart={this.props.subtractProductFromCart}
                          product={product}
                          addProductToCart={addProductToCart}
                          addToast={addToast}
                          cartProductQuantity={cartProductQuantity}
                          isZoomEnabled={false}
                          storeType={this.props.storeInfo.storeInfo?.storeType}
                          review={this.props.productDetails?.reviews?.length}
                          reviewsCount={this.props.productDetails?.reviewsCount}
                          toasts={this.props.toasts}
                          wishListFeature={features?.features?.wishList}
                          productVideoFeature={features?.features?.productVideo}
                          finalProduct={finalProduct}
                          hocArgs={hocArgs}
                        />
                      ) : null}
                      <div className="flex lg:hidden xl:flex mt-10 md:mt-0 md:absolute mb-20 md:mb-0 bottom-0 md:right-42 h-38 md:h-50 items-center w-fit border border-lightGray border-opacity-15 px-16">
                        <div className="bg-themeBg w-fit justify-center">
                          <Share className="w-full" product={product} />
                        </div>
                      </div>
                    </div>

                    <div className="mt-30 md:mt-40 container md:mx-auto cursor-pointer md:px-42">
                      <div className="container md:pl-64 md:pr-56 py-20 md:py-36 shadow-testimonialCardCard">
                        <div className="flex w-full justify-between items-center">
                          <div
                            className={classnames(
                              'font-medium text-black flex flex-col w-fit text-14 md:text-16 leading-20 md:leading-24 ',
                            )}
                            font-customisation="section-heading"
                            color-customisation="page-heading"
                          >
                            Description
                            <div className="flex flex-row min-w-100 md:min-w-200 items-center mt-6">
                              <div className="h-4 min-w-60 md:min-w-98 bg-yellow"></div>
                              <div className="bg-black opacity-15 h-1 w-full"></div>
                            </div>
                          </div>
                        </div>
                        <>
                          {product.description ? (
                            <div className="description mt-20">
                              <Editor name="productLongDescription" value={finalProduct.description} readonly={true} />
                            </div>
                          ) : null}
                        </>
                      </div>
                    </div>

                    {productDetails.bundle && (
                      <div className="bg-productBundle-extraLightGray py-70 mt-60">
                        <div className="container mx-auto">
                          <ProductBundle
                            productsBundle={productDetails.bundle}
                            productId={product?.id}
                            addToBundleProductInCart={addBundleProductToCartSuccess}
                            priceClassName={'text-black'}
                            borderClassName={'border-divider'}
                            className={
                              'ripple bg-white border-2 font-bold hover:bg-lightGray hover:bg-opacity-15 rounded-none'
                            }
                          />
                        </div>
                      </div>
                    )}
                    {!hideReviewsSection ? (
                      <div
                        id="product-reviews"
                        className="container mt-20 md:mx-auto cursor-pointer md:px-42 mb-30 md:mb-50"
                      >
                        <div className="container px-0 shadow-testimonialCardCard">
                          <div
                            className="flex w-full justify-between items-center md:pl-64 md:pr-56 py-20 md:py-36 px-16 md:px-0"
                            onClick={(e) => {
                              e.preventDefault();
                              if (productDetails?.reviews?.length) this.setReview();
                            }}
                          >
                            <div
                              className={classnames(
                                'font-medium w-fit flex flex-col text-black text-14 md:text-16 leading-20 md:leading-24',
                                {},
                              )}
                              font-customisation="section-heading"
                              color-customisation="page-heading"
                            >
                              Reviews ({productDetails.reviewsCount})
                              <div className="flex flex-row min-w-100 md:min-w-200 items-center mt-6">
                                <div className="h-4 min-w-60 md:min-w-98 bg-yellow"></div>
                                <div className="bg-black opacity-15 h-1 w-full"></div>
                              </div>
                            </div>
                            {features?.features?.buyerLogin && (
                              <div className="flex items-center">
                                <div className="mr-20 md:mr-30">
                                  <Link
                                    to={
                                      getBuyerJWTToken()
                                        ? `/product/${product?.slug}/review`
                                        : `/account/login?redirect_url=/product/${product?.slug}/review`
                                    }
                                  >
                                    <button
                                      type="submit"
                                      className="font-normal md:font-medium bg-yellow h-22 md:h-40 px-12 text-14 md:text-16 leading-22 text-black cursor-pointer"
                                      button-customisation="page-button"
                                    >
                                      Write a Review
                                    </button>
                                  </Link>
                                </div>
                                <img
                                  src={Down}
                                  alt="down"
                                  className={this.state.review ? 'transform -rotate-180' : null}
                                />
                              </div>
                            )}
                          </div>
                          {this.state.review ? (
                            <div className={classnames('')}>
                              <Rating
                                productSlug={product?.slug}
                                isNextReviewsLoading={productDetails.isNextReviewsLoading}
                                isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                                reviewsCount={productDetails.reviewsCount}
                                nextReviewsUrl={productDetails.nextReviewsUrl}
                                reviews={productDetails.reviews}
                                productId={product?.id}
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    <div className="container hidden md:hidden lg:flex xl:hidden px-0 mx-auto justify-center">
                      <div className="flex h-50 mb-50 items-center w-fit border border-lightGray border-opacity-15 px-16">
                        <div className="bg-themeBg w-fit justify-center">
                          <Share className="w-full" product={product} />
                        </div>
                      </div>
                    </div>
                  </>
                );
              }}
            />
          ) : (
            <ProductAddToCartHOC
              variantSetToMinQuantity={true}
              disableSuccessToasts={() => false}
              product={product}
              render={(hocArgs) => {
                const { finalProduct } = hocArgs;
                return (
                  <>
                    <div className="w-full shadow-breadCrumb">
                      <div
                        className="container md:mx-auto flex items-center text-black py-10 md:py-18 md:pl-62"
                        font-customisation="para-text"
                      >
                        <div className="flex items-center text-12 md:text-16 font-normal">
                          <Link to="/" className="mr-14 cursor-pointer text-theme" color-customisation="page-body-text">
                            Home
                          </Link>
                          <img src={BreadcrumbRightArrow} className="h-10 md:h-12 mr-14" alt="arrow" />
                          <div className="font-bold" color-customisation="page-body-text">
                            {product?.title ?? ''}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={classnames('container md:mx-auto md:px-0 flex text-black md:pl-42', {
                        'h-10 md:h-42': !this.props.toasts?.length,
                        'my-10 md:my-24': this.props.toasts?.length,
                      })}
                    >
                      <Toasts toasts={this.props.toasts} addToast={addToast} removeToast={removeToast} />
                    </div>
                    <div className="container border-b border-lightGray border-opacity-15 md:border-0 relative md:px-42 md:mx-auto flex flex-wrap md:flex-no-wrap mb-5">
                      {productDetails.isFetched ? (
                        <Event
                          subtractProductFromCart={this.props.subtractProductFromCart}
                          product={product}
                          addProductToCart={addProductToCart}
                          addToast={addToast}
                          cartProductQuantity={cartProductQuantity}
                          storeType={this.props.storeInfo.storeInfo?.storeType}
                          review={this.props.productDetails?.reviews?.length}
                          wishListFeature={features?.features?.wishList}
                          finalProduct={finalProduct}
                          hocArgs={hocArgs}
                          productVideoFeature={features?.features?.productVideo}
                        />
                      ) : null}
                      <div className="flex lg:hidden xl:flex mt-10 md:mt-0 md:absolute mb-20 md:mb-0 bottom-0 md:right-42 h-38 md:h-50 items-center w-fit border border-lightGray border-opacity-15 px-16">
                        <div className="bg-themeBg w-fit justify-center">
                          <Share className="w-full" product={product} />
                        </div>
                      </div>
                    </div>
                    <div className="mt-30 md:mt-40 container md:mx-auto cursor-pointer md:px-42">
                      <div className="container md:mx-auto cursor-pointer md:px-42">
                        <div className="container md:pl-64 md:pr-56 py-20 md:py-36 shadow-testimonialCardCard">
                          <div className="flex w-full justify-between items-center">
                            <div
                              className={classnames(
                                'font-medium text-black flex flex-col w-fit text-14 md:text-16 leading-20 md:leading-24 ',
                              )}
                              font-customisation="section-heading"
                              color-customisation="page-heading"
                            >
                              Description
                              <div className="flex flex-row min-w-100 md:min-w-200 items-center mt-6">
                                <div className="h-4 min-w-60 md:min-w-98 bg-yellow"></div>
                                <div className="bg-black opacity-15 h-1 w-full"></div>
                              </div>
                            </div>
                          </div>
                          <>
                            {product.description ? (
                              <div className="description mt-20">
                                <Editor
                                  name="productLongDescription"
                                  value={finalProduct.description}
                                  readonly={true}
                                />
                              </div>
                            ) : null}
                          </>
                        </div>
                      </div>
                      <div
                        id="product-reviews"
                        className="container mt-20 md:mx-auto cursor-pointer md:px-42 mb-30 md:mb-40"
                      >
                        <div className="container px-0 shadow-testimonialCardCard">
                          <div
                            className="flex w-full justify-between items-center md:pl-64 md:pr-56 py-20 md:py-36 px-16 md:px-0"
                            onClick={(e) => {
                              e.preventDefault();
                              if (productDetails?.reviews?.length) this.setReview();
                            }}
                          >
                            <div
                              className={classnames(
                                'font-medium w-fit flex flex-col text-black text-14 md:text-16 leading-20 md:leading-24',
                                {},
                              )}
                              font-customisation="section-heading"
                              color-customisation="page-heading"
                            >
                              Reviews({productDetails.reviewsCount})
                              <div className="flex flex-row min-w-100 md:min-w-200 items-center mt-6">
                                <div className="h-4 min-w-60 md:min-w-98 bg-yellow"></div>
                                <div className="bg-black opacity-15 h-1 w-full"></div>
                              </div>
                            </div>
                            {features?.features?.buyerLogin && (
                              <div className="flex items-center">
                                <div className="mr-12">
                                  <Link
                                    to={
                                      getBuyerJWTToken()
                                        ? `/product/${product?.slug}/review`
                                        : `/account/login?redirect_url=/product/${product?.slug}/review`
                                    }
                                  >
                                    <button
                                      type="submit"
                                      className="font-normal md:font-medium bg-yellow h-22 md:h-40 px-12 text-14 md:text-16 leading-22 text-black cursor-pointer"
                                      button-customisation="page-button"
                                    >
                                      Write a Review
                                    </button>
                                  </Link>
                                </div>
                                <img
                                  src={Down}
                                  alt="down"
                                  className={this.state.review ? 'transform -rotate-180' : null}
                                />
                              </div>
                            )}
                          </div>
                          {this.state.review ? (
                            <div className={classnames('')}>
                              <Rating
                                productSlug={product?.slug}
                                isNextReviewsLoading={productDetails.isNextReviewsLoading}
                                isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                                reviewsCount={productDetails.reviewsCount}
                                nextReviewsUrl={productDetails.nextReviewsUrl}
                                reviews={productDetails.reviews}
                                productId={product?.id}
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="container hidden md:hidden lg:flex xl:hidden px-0 mx-auto justify-center">
                      <div className="flex h-50 mb-50 items-center w-fit border border-lightGray border-opacity-15 px-16">
                        <div className="bg-themeBg w-fit justify-center">
                          <Share className="w-full" product={product} />
                        </div>
                      </div>
                    </div>
                  </>
                );
              }}
            />
          )}
        </ProductDetailsWrapper>
      </PageLayout>
    );
  }
}

export default connect(
  ({ cart, features, productDetails, products, toasts, categories, recentlyViewed, storeInfo }: RootState) => ({
    storeInfo,
    features,
    toasts,
    cart,
    products,
    categories,
    productDetails,
    recentlyViewed,
  }),
  {
    fetchProductsRequest,
    fetchProductDetailsRequest,
    fetchCategoriesRequest,
    fetchProductReviewsRequest,
    addToast,
    removeToast,
    addProductToCart,
    subtractProductFromCart,
    fetchProductBundleRequest,
    addBundleProductToCartSuccess,
  },
)(ProductDetails);
